import { Model } from '@vuex-orm/core'

export class AbsenceType extends Model {
  static entity = 'absenceTypes'

  static fields () {
    return {
      id: this.attr(null),
      name: this.attr(''),
      description: this.attr(''),
      type: this.attr(''),
      is_countable: this.attr(false)
    }
  }
}

export default AbsenceType
